import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { GetVodafoneTemlikRequest, GetVodafoneTemlikResponse } from '../models/model'

export class GetTemlikDetailListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'VodafoneReports/GetVodafoneTemlikDetailList',
      requesterInfo,
    })
  }

  public async getDetailList(request: GetVodafoneTemlikRequest): Promise<GetVodafoneTemlikResponse[]> {
    return await this.postAsync<GetVodafoneTemlikResponse[]>(request)
  }
}